export enum SalaryRequestStatusDictionary {
  Pending = 'Pending',
  Approved = 'Approved',
  Declined = 'Declined',
}
